module.exports = __webpack_public_path__ + "img/icon-add.e7fd00be.svg";